import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/app/providers/authentication.service";

@Component({
  selector: "app-guest-event-toy-contribute",
  templateUrl: "./guest-event-toy-contribute.component.html",
  styleUrls: ["./guest-event-toy-contribute.component.scss"],
})
export class GuestEventToyContributeComponent implements OnInit {
  constructor(private router: Router,
    private authService: AuthenticationService,
  ) {}

  async ngOnInit() {
    await this.authService.isAuthenticated();
  }

  gotoBirthdayCard() {
    this.router.navigate(["/guest/12342135/birthdaycard/sign"]);
  }

  back() {
    this.router.navigate(["/guest/123412412/toy"]);
  }
}
